import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons'
import { Button } from '@mantine/core'
import { useState } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreBookingProduct } from '@flecto/types'
import { Icon, Modal, useModal } from '@flecto/ui'

import { FormBookingProduct } from './FormBookingProduct'
import styles from './styles.module.css'

export type ModalBookingProductUpdateProps = {
  bookingProduct?: CoreBookingProduct
  open?: boolean
}

export function ModalBookingProductUpdate({
  bookingProduct,
  open,
}: ModalBookingProductUpdateProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })
  const [isUpdating, setIsUpdating] = useState(false)
  const { closeModal } = useModal()
  const [resetCustomValue, setResetCustomValue] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  return (
    <Modal size='md'>
      <Modal.Close />
      <Modal.Title>{bookingProduct?.product.title}</Modal.Title>
      <Modal.Cancel />
      <Modal.Submit
        type='submit'
        form='form-booking-product'
        loading={isUpdating}
        preventClose
      >
        {tActions('save')}
      </Modal.Submit>
      <Modal.Content>
        <FormBookingProduct
          open={open}
          id='form-booking-product'
          bookingProduct={bookingProduct}
          onChangeLoading={setIsUpdating}
          onSuccess={closeModal}
          setResetCustomValue={setResetCustomValue}
          resetCustomValue={resetCustomValue}
          setIsDirty={setIsDirty}
        />
      </Modal.Content>
      <Modal.FooterExtra>
        <Button
          className={styles.resetCustomValueButton}
          px={0}
          variant='transparent'
          color='blue'
          disabled={!isDirty}
          onClick={() => setResetCustomValue(true)}
        >
          <Icon icon={faArrowRotateLeft} mr='sm' />
          {t('modal_booking_items_reset_custom_values')}
        </Button>
      </Modal.FooterExtra>
    </Modal>
  )
}
